import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const migrationFromBitrix = () =>
  requestsTemplates.get(mainPath.replace('/api', ''), "/bitrix/migration/departments");
